import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'black-how-it-works-section',
  templateUrl: './how-it-works-section.component.html',
  styleUrls: ['./how-it-works-section.component.css'],
  standalone: true,
  imports: [RouterModule],
})
export class HowItWorksSectionComponent {}
